import { createContext } from "react";
import { initialDisplaySettings } from "../init";

const DisplaySettingsContext = createContext(initialDisplaySettings);

export default DisplaySettingsContext;
